export const SAVE_PROFILE = 'SAVE_PROFILE';
export const LOAD_PROFILE = 'LOAD_PROFILE';
export const CREATE_PROFILE = 'CREATE_PROFILE';
export const SELECT_PROFILE = 'SELECT_PROFILE';
export const LOAD_SELECTED_PROFILE = 'LOAD_SELECTED_PROFILE';

